import { downloadFile } from '@/api/file'

const downloadFileToLocal = async (data: any, fileNameNew: string) => {
  try {
    const response = await downloadFile(data)// Lấy tên file từ header Content-Disposition
    const disposition = response.headers['content-disposition']
    let fileName = fileNameNew || 'file_name' // Nếu không có tên file, đặt tên mặc định

    if (disposition && disposition.includes('attachment')) {
      const matches = disposition.match(/filename="(.+)"/)
      if (matches != null && matches[1])
        fileName = matches[1] // Lấy tên file từ header
    }

    // Tạo một URL từ blob để sử dụng làm liên kết tải xuống
    const url = window.URL.createObjectURL(new Blob([response.data]))

    // Tạo một đối tượng <a> để download file
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName) // Tên file khi tải về
    document.body.appendChild(link)
    link.click() // Thực hiện click để tải file về

    // Giải phóng URL blob sau khi tải xuống xong
    window.URL.revokeObjectURL(url)
  }
  catch (error) {
    console.log('Lỗi khi download file về máy tính local: ', error)
    throw error
  }
}

export { downloadFileToLocal }
